module.exports = __webpack_public_path__ + "static/media/3.ebce3941.jpg";